import React from 'react';
import { List, Datagrid, TextField } from 'react-admin';
import { ScopeField } from './ScopeField';

export default function PartnersTokenList(props) {
  return (
    <List {...props} perPage={10}>
      <Datagrid rowClick='show'>
        <TextField source='identifier' label='identifier' />
        <TextField source='extra.creditLead.tracking.agent' label='Agent' />
        <TextField source='extra.creditLead.tracking.team' label='Team' />
        <ScopeField source='scope' />
      </Datagrid>
    </List>
  );
}
